(() => {
  if (window.__malleDeliveryEstimateInit) return;
  window.__malleDeliveryEstimateInit = true;

  const DEFAULT_MIN_DAYS = 2;
  const DEFAULT_MAX_DAYS = 5;
  const DEFAULT_CUTOFF_HOUR = 14;

  /**
   * @param {Date} date
   * @param {number} days
   * @returns {Date}
   */
  function addBusinessDays(date, days) {
    const result = new Date(date.getTime());
    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      const weekday = result.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }

    return result;
  }

  /**
   * @param {number} cutoffHour
   * @returns {Date}
   */
  function getOrderStartDate(cutoffHour) {
    const start = new Date();
    start.setHours(0, 0, 0, 0);

    const now = new Date();
    const afterCutoff = now.getHours() >= cutoffHour;
    const isWeekend = now.getDay() === 0 || now.getDay() === 6;

    if (afterCutoff || isWeekend) {
      start.setDate(start.getDate() + 1);
    }

    while (start.getDay() === 0 || start.getDay() === 6) {
      start.setDate(start.getDate() + 1);
    }

    return start;
  }

  /**
   * @param {Date} date
   * @returns {string}
   */
  function formatMonth(date) {
    return new Intl.DateTimeFormat('de-DE', { month: 'long' }).format(date);
  }

  /**
   * @param {Date} minDate
   * @param {Date} maxDate
   * @returns {string}
   */
  function formatDeliveryRange(minDate, maxDate) {
    const minDay = minDate.getDate();
    const maxDay = maxDate.getDate();

    if (minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear()) {
      return `${minDay}. und ${maxDay}. ${formatMonth(minDate)}`;
    }

    const minLabel = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long' }).format(minDate);
    const maxLabel = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long' }).format(maxDate);
    return `${minLabel} und ${maxLabel}`;
  }

  /**
   * @param {number} minDays
   * @param {number} maxDays
   * @param {number} cutoffHour
   * @returns {{ minDate: Date, maxDate: Date }}
   */
  function computeDeliveryWindow(minDays, maxDays, cutoffHour) {
    const start = getOrderStartDate(cutoffHour);
    return {
      minDate: addBusinessDays(start, minDays),
      maxDate: addBusinessDays(start, maxDays),
    };
  }

  /**
   * @param {HTMLElement} root
   */
  function renderEstimate(root) {
    const line = root.querySelector('[data-delivery-line]');
    if (!line) return;

    const minDays = Number.parseInt(root.dataset.minDays || '', 10) || DEFAULT_MIN_DAYS;
    const maxDays = Number.parseInt(root.dataset.maxDays || '', 10) || DEFAULT_MAX_DAYS;
    const cutoffHour = Number.parseInt(root.dataset.cutoffHour || '', 10);
    const cutoff = Number.isFinite(cutoffHour) ? cutoffHour : DEFAULT_CUTOFF_HOUR;
    const { minDate, maxDate } = computeDeliveryWindow(minDays, maxDays, cutoff);
    const range = formatDeliveryRange(minDate, maxDate);

    line.textContent = `Bei Bestellung heute voraussichtlich zwischen ${range} bei dir.`;
  }

  function init() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(renderEstimate);
  }

  window.MalleDeliveryEstimate = {
    init,
    renderEstimate,
    computeDeliveryWindow,
    formatDeliveryRange,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
